import { createStyles, Grid, List, makeStyles } from '@material-ui/core';
import React from 'react';
import { ICustomer } from '../../models/ICustomers';
import EntryItem from '../EntryItem/EntryItem.component';
import SearchBar from '../SearchBar/SearchBar.component';

const useStyles = makeStyles((theme) =>
    createStyles({
        root: {
            flex: 1,
            padding: theme.spacing(0.5),
        },
        searchBar: {
            marginBottom: theme.spacing(3),
            [theme.breakpoints.down('sm')]: {
                marginBottom: 0,
            },
            [theme.breakpoints.up('md')]: {
                marginBottom: theme.spacing(1),
            },
        },
        input: {
            backgroundColor: '#fff',
        }
    }),
);

interface Props {
    data: ICustomer[]
    searchValue: string,
    setSearchValue: (s: string) => void,
    onDetailsClick: (entry: ICustomer) => void
    onDeleteClick: (entry: ICustomer) => void
}

export default function CustomersList({
    data,
    searchValue,
    setSearchValue,
    onDeleteClick,
    onDetailsClick
}: Props) {
    const classes = useStyles();

    return (
        <Grid container spacing={3} className={classes.root}>
            <Grid direction="row" justify="center" alignItems="center" container spacing={2} className={classes.searchBar}>
                <Grid xs item>
                    <SearchBar
                        value={searchValue}
                        setValue={setSearchValue}
                        placeholder="Search Customers..."
                    />
                </Grid>
            </Grid>
            <List style={{ flex: 1 }}>
                {data.map((item, index) =>
                    <EntryItem
                        entry={item}
                        onDetailsClick={onDetailsClick}
                        onDeleteClick={onDeleteClick}
                        key={index}
                    />
                )}
            </List>
        </Grid>
    );
}
